import React from 'react';

// 푸터 법적 고지 줄(Copyright / 사업자등록번호) 글자색 커스텀 대상 랜딩
// (eventclinic·dentaleventhub의 templateRenderer.js FOOTER_STYLE_CONFIG 와 동일한 방식)
const FOOTER_LEGAL_COLOR_ADNUMS = ['A440', 'A897', 'A967', 'A968', 'A969', 'A970', 'A972', 'A973', 'A974', 'A975', 'A988', 'A989', 'A723', 'A1002', 'A999', 'A1000', 'A1001', 'A061', 'A635', 'A248', 'A405', 'A636'];
export const FOOTER_LEGAL_COLOR = '#5a5a5a';

const LEGAL_LINE = /^(Copyright|사업자등록번호)/;

// 대상 랜딩이면 footerDetail 문자열을 줄 단위로 나눠 법적 고지 줄만 색을 입힌 노드로 변환
export function applyFooterLegalColor(footerDetail, adNumber, legalColor) {
  // footerLegalColor(#RRGGBB)가 있으면 대상 랜딩 조건과 무관하게 해당 색 + 크기 클래스 적용
  if (footerDetail && typeof legalColor === 'string' && /^#[0-9a-fA-F]{6}$/.test(legalColor)) {
    return footerDetail.split(/(\r?\n)/).map((part, i) =>
      LEGAL_LINE.test(part) ? (
        <span key={i} className="footer-legal-text" style={{ color: legalColor }}>{part}</span>
      ) : (
        <React.Fragment key={i}>{part}</React.Fragment>
      )
    );
  }
  // 지정 랜딩이거나, 푸터 Copyright 줄이 "· 더봄치과의원"으로 끝나는 랜딩이면 적용
  const isDeobomFooter = /Copyright[^\n]*·\s*더봄치과의원/.test(footerDetail || '');
  if (!footerDetail || !(FOOTER_LEGAL_COLOR_ADNUMS.includes(adNumber) || isDeobomFooter)) {
    return footerDetail;
  }
  // Copyright 줄과 사업자등록번호 줄 사이 빈 줄을 없애 줄바꿈 1개로 통일 (templateRenderer.js 와 동일)
  const text = footerDetail.replace(/(Copyright[^\n]*?)\s*\n\s*\n\s*(사업자등록번호)/g, '$1\n$2');
  return text.split(/(\r?\n)/).map((part, i) =>
    LEGAL_LINE.test(part) ? (
      <span key={i} className="footer-legal-text" style={{ color: FOOTER_LEGAL_COLOR }}>{part}</span>
    ) : (
      <React.Fragment key={i}>{part}</React.Fragment>
    )
  );
}
